import { render, staticRenderFns } from "./PostUniversity.vue?vue&type=template&id=3c122c98&scoped=true&"
import script from "./PostUniversity.vue?vue&type=script&lang=js&"
export * from "./PostUniversity.vue?vue&type=script&lang=js&"
import style0 from "./PostUniversity.vue?vue&type=style&index=0&id=3c122c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c122c98",
  null
  
)

export default component.exports